(function($, undefined) {
    const kendo = window.kendo,
        extend = $.extend,
        Class = kendo.Class;

    const Command = Class.extend({
        init: function(options) {
            this.options = options;
            this.grid = options.grid;
        }
    });

    const MoveGroupCommand = Command.extend({
        exec: function() {
            const that = this,
                grid = that.grid,
                groupable = grid.groupable,
                options = that.options,
                target = options.target.closest(".k-chip"),
                method = options.dir === "next" ? "after" : "before",
                position = options.dir === "next" ? target.next() : target.prev();

            position[method](target);
            groupable._change();
        },
    });

    const SortCommand = Command.extend({
        exec: function() {
            const that = this,
                grid = that.grid,
                dataSource = grid.dataSource,
                options = that.options,
                dir = options.dir,
                field = grid._getCellField(options.target),
                multipleMode = grid.options.sortable.mode && grid.options.sortable.mode === "multiple",
                compare = grid.options.compare;

                let length, idx,
                    sort = dataSource.sort() || [];

            if (multipleMode) {
                for (idx = 0, length = sort.length; idx < length; idx++) {
                    if (sort[idx].field === field) {
                        sort.splice(idx, 1);
                        break;
                    }
                }
                sort.push({ field: field, dir: dir, compare: compare });
            } else {
                sort = [{ field: field, dir: dir, compare: compare }];
            }

            dataSource.sort(sort);
        },
    });

    const AddCommand = Command.extend({
        exec: function() {
            const that = this,
                grid = that.grid;

            grid.addRow();
        }
    });

    const EditCommand = Command.extend({
        exec: function() {
            const that = this,
                grid = that.grid,
                inCellMode = grid._editMode() === "incell",
                target = inCellMode ? that.options.target : that.options.target.closest("tr");

            if (inCellMode) {
                grid.editCell(target);
            } else {
                grid.editRow(target);
            }
        }
    });

    const DeleteCommand = Command.extend({
        exec: function() {
            const that = this,
                grid = that.grid,
                target = that.options.target.closest("tr");

            grid.removeRow(target);
        }
    });

    const CopySelectionCommand = Command.extend({
        exec: function() {
            const that = this,
                grid = that.grid,
                withHeaders = that.options.withHeaders;

            grid.copySelectionToClipboard(withHeaders);
        }
    });

    const SelectRowCommand = Command.extend({
        exec: function() {
            const that = this,
                grid = that.grid,
                selectMode = kendo.ui.Selectable.parseOptions(grid.options.selectable),
                target = that.options.target.closest("tr");

            grid.select(selectMode.cell ? target.find('td') : target);
        }
    });

    const SelectAllRowsCommand = Command.extend({
        exec: function() {
            const that = this,
                grid = that.grid,
                selectMode = kendo.ui.Selectable.parseOptions(grid.options.selectable),
                rows = grid.items();

            grid.select(selectMode.cell ? rows.find('td') : rows);
        }
    });

    const ClearSelectionCommand = Command.extend({
        exec: function() {
            const that = this,
                grid = that.grid;

            grid.clearSelection();
        }
    });

    const ReorderRowCommand = Command.extend({
        exec: function() {
            const that = this,
                grid = that.grid,
                dir = that.options.dir,
                target = that.options.target.closest("tr"),
                index = target.index();

            let newIndex;

            switch (dir) {
                case "up":
                    newIndex = index - 1;
                    break;
                case "down":
                    newIndex = index + 2;
                    break;
                case "top":
                    newIndex = 0;
                    break;
                case "bottom":
                    newIndex = grid.items().length;
                    break;
            }

            grid.reorderRowTo(target, newIndex);
        }
    });

    const ExportPDFCommand = Command.extend({
        exec: function() {
            const that = this,
                grid = that.grid;

            grid.saveAsPDF();
        }
    });

    const ExportExcelCommand = Command.extend({
        exec: function() {
            const that = this,
                selection = that.options.selection,
                withHeaders = that.options.withHeaders,
                grid = that.grid;

            if (selection) {
                grid.exportSelectedToExcel(withHeaders);
            } else {
                grid.saveAsExcel();
            }
        }
    });

    const ExportCSVCommand = Command.extend({
        exec: function() {
            const selection = this.options.selection;
            const withHeaders = this.options.withHeaders;
            const grid = this.grid;

            if (selection) {
                grid.exportSelectedToCSV(withHeaders);
            } else {
                grid.saveAsCSV();
            }
        }
    });

    const PinTopCommand = Command.extend({
        exec: function() {
            const grid = this.grid;
            const target = this.options.target.closest("tr");

            grid.pinRows(target, "top");
        }
    });

    const PinBottomCommand = Command.extend({
        exec: function() {
            const grid = this.grid;
            const target = this.options.target.closest("tr");


            grid.pinRows(target, "bottom");
        }
    });

    const UnpinCommand = Command.extend({
        exec: function() {
            const grid = this.grid;
            const target = this.options.target.closest("tr");

            grid.unpinRows(target);
        }
    });

    kendo.ui.grid = kendo.ui.grid || {};

    extend(kendo.ui.grid, {
        GridCommand: Command,
        commands: {
            SortCommand: SortCommand,
            AddCommand: AddCommand,
            EditCommand: EditCommand,
            DeleteCommand: DeleteCommand,
            CopySelectionCommand: CopySelectionCommand,
            SelectRowCommand: SelectRowCommand,
            SelectAllRowsCommand: SelectAllRowsCommand,
            ClearSelectionCommand: ClearSelectionCommand,
            ReorderRowCommand: ReorderRowCommand,
            ExportPDFCommand: ExportPDFCommand,
            ExportExcelCommand: ExportExcelCommand,
            ExportCSVCommand: ExportCSVCommand,
            MoveGroupCommand: MoveGroupCommand,
            PinTopCommand: PinTopCommand,
            PinBottomCommand: PinBottomCommand,
            UnpinCommand: UnpinCommand
        }
    });
})(window.kendo.jQuery);